// src/app/modules/Settings/SettingsPage.jsx
import React from "react";
import { Settings } from "./main";

export function SettingsPage() {
  return <Settings />;
}